import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Global } from './global';
// import * as engContent from '../assets/languagesConfig/en.json';
// import * as moment from 'moment';
import { CommonService } from './services/common.service'
// import { NgxUiLoaderService } from 'ngx-ui-loader';
// import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { configObj } from './configuration';
// import { DomSanitizer } from '@angular/platform-browser';
// import * as engContent from '../assets/languagesConfig/en.json';
// import { Angulartics2GoogleAnalytics } from 'angulartics2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
// import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  @ViewChild('timeOutModal') timeOutModal: any;
  @ViewChild('tnCModel') tnCModel: any;
  @ViewChild('otpModal') otpModal: any;
  @ViewChild('setupSucessful') setupSucessful: any;
  @ViewChild('optOutModal') optOutModal: any;
  @ViewChild('createPinModal') createPinModal: any;
  @ViewChild('dataNotFoundModal') dataNotFoundModal: any;
  @ViewChild('failureModal') failureModal: any;
  @ViewChild('incorrectOtpModal') incorrectOtpModal: any;
  // @ViewChild('cardBlockModal') cardBlockModal: any;
  @ViewChild('languageModal') languageModal: any;
  @ViewChild('experienceRate') experienceRate: any;
  @ViewChild('feedbackSuccess') feedbackSuccess: any;
  @ViewChild('getAddOnCard') getAddOnCard: any;
  @ViewChild('cardUnblocked') cardUnblocked: any;
  @ViewChild('crossSellProduct') crossSellProduct: any;
  @ViewChild('attemptExhaustModal') attemptExhaustModal: any;

  

  modalOtpInputConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: true,
    placeholder: '',
    inputStyles: {
      'width': '60px',
      'height': '60px',
      'font-size': '14px'
    }
  }
  public languageoption: any = [
    { full: 'English', short: 'en', langFull: 'English' },
    { full: 'हिन्दी', short: 'hi', langFull: 'Hindi' },
    { full: 'हिन्दी', short: 'hi', langFull: 'Hindi' },
    { full: 'ಕನ್ನಡ', short: 'kn', langFull: 'Kannada' },
    { full: 'తెలుగు', short: 'te', langFull: 'Telugu' },
    { full: 'தமிழ்', short: 'ta', langFull: 'Tamil' },
    { full: 'ਪੰਜਾਬੀ', short: 'pb', langFull: 'Punjabi' },
    { full: 'বাংলা', short: 'bn', langFull: 'Bangla' },
    { full: 'मराठी', short: 'mr', langFull: 'Marathi' },
    { full: 'ગુજરાતી', short: 'gu', langFull: 'Gujarati' },
    { full: 'മല്യത്തിൽ', short: 'ma', langFull: 'Malayalam' }
  ];
  // public engLang = engContent['default'];
  public config = configObj;
  public modalReference: any;
  public intervalSecond: any;
  public intervalMain: any;
  public countdownTime: number;
  public countdownTimeSecond: number;
  public setUpSuccesFulChecks: string;
  public otpNumber: any;
  public clearIntervalForSetupSuccess
  private pinSetupRef
  public showPopper: boolean = false
  public blockTimeOutVar;
  public crossSellData: any;
  private tnCModalRef: any;
  attemptExhaustRef
  constructor(
    private modalService: NgbModal,
    public global: Global,
    public commonServices: CommonService,
    private ngxService: NgxUiLoaderService,
    private toastr: ToastrService,
    private router: Router,
    // private sanitizer: DomSanitizer,
    // private activatedRoute: ActivatedRoute,
    // private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    // private bottomSheet: MatBottomSheet,
    private cdref: ChangeDetectorRef,
  ) {
    // angulartics2GoogleAnalytics.startTracking();
  }
  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e) {
    if ((this.commonServices && this.commonServices.userLogedIn) && !this.intervalSecond) {
      clearInterval(this.intervalMain);
      clearInterval(this.intervalSecond);
      this.firstTimeout();
    } else {
      clearInterval(this.intervalMain);
    }
  }
  ngOnInit(): void {

    this.commonServices.trackUser('app_loaded_successfully', 'load', null);
    if (window && window.sessionStorage) {
      this.commonServices.trackUser('enabled_sessionStorage', 'load', null)
    }
    else {
      this.commonServices.trackUser('disabled_sessionStorage', 'load', null)
    }

    var x = window.matchMedia("(max-width: 992px)")
    if (x.matches) {
      this.global['mobile'] = true;
    } else {
      this.global['mobile'] = false;
    }

    setTimeout(() => {
      if (this.commonServices && this.commonServices.userLogedIn) {
        this.firstTimeout();
      }
    }, 10);
  }
  public ratingValue: number = 0
  public transactionPrefrenceSet = [
    "Control your Credit Card usage by enabling/disabling your Card for domestic/international transactions at POS/ATM/Online sites/Contactless terminals/Mail Order Telephone Order (MOTO).",
    "This feature is provided to you as an additional security measure for your Credit Card usage.",
    "We recommend you to keep your domestic POS transaction preference enabled to ensure uninterrupted usage of your Credit Card.",
    "To set transaction limits on your Credit Card, please click on the ‘Set Card Level Transaction Limit’ tab."
  ]
  public cardTransactionLimit = [
    "Manage your Credit Card usage by setting Card level limit for your transactions at POS/ATM/Online sites/Contactless terminals/Mail Order Telephone Order (MOTO).",
    "Payment through the contactless mode is allowed for a maximum limit of  ₹5,000 in a single transaction. For any transaction amount which is more than  ₹5,000, you will be asked to enter your Credit Card PIN. This limit is common for all customers. Number of consecutive NFC transactions allowed are governed by risk rules of the Bank.",
    "The set limits will be applicable per billing cycle which means you can transact up to the set limits each billing cycle."
  ]
  public rewardPointsList = [
    "Cardholder will be eligible for benefits under this program only if they activate the card by using the link sent to them via SMS/email to set pin/card controls",
    "Fulfillment of the offer will be done within 90 days of the end of the Program Period",
    "Program end date is 31st December 2024",
    "In case the Cardholder has any issues/disputes regarding the program he/she must raise his or her concerns within 30 days from voucher issuance date. Any disputes raised post this date will not be entertained by the Bank",
    "IndusInd Bank shall not be liable or responsible for non-receipt or delivery of any SMS/other communication relating to this Program due to any reason beyond the control of IndusInd Bank"
  ]
  public flipkartVoucherList = [
    "Maximum of 1 Gift Voucher will be given to one Cardholder during the Offer Period",
    "Vouchers will be shared with clients on their registered mobile numbers and emails latest by 90 days from the date of transaction",
    "Program end date is 31st December 2024",
    "In case the Cardholder has any issues/disputes regarding the voucher he/she must raise his or her concerns within 30 days from voucher issuance date. Any disputes raised post this date will not be entertained by the Bank",
    "Standard terms and conditions of Flipkart Gift Voucher will apply for utilization of the vouchers",
    "IndusInd Bank shall not be liable or responsible for non-receipt or delivery of any SMS/other communication relating to this Program due to any reason beyond the control of IndusInd Bank"
  ]
  public timesPrimeList = [
    "Offer Headline: Avail a complimentary Times Prime Membership with an eligible Visa Signature Card.",
    "Booking Channels: Times Prime Website, Mobile Site, Android & iOS App",
    "Offer Validity: April 1,2025 - March 31,2026",
  ]
  // public checkSession() {
  //   this.commonServices.checkSession().then(
  //     data => {
  //     }
  //   ).catch(
  //     error => {
  //       this.router.navigate(['login'])
  //     }
  //   );
  // }


  public firstTimeout() {
    this.countdownTime = 900;
    this.intervalMain = setInterval(() => {
      if (this.commonServices && this.commonServices.userLogedIn) {
        this.countdownTime = this.countdownTime - 1;
        if (this.countdownTime == 0) {
          // this.opentimeOutPopup();
          this.timeoutLogout()
          clearInterval(this.intervalMain);
        }
      }
    }, 1000);
  }

  timeoutLogout() {
    this.commonServices.logout().subscribe(
      data => {
        this.commonServices.resetData()
        setTimeout(() => {
          // this.router.navigate(['login'])
          this.commonServices.loginRedirectionHandle()
        }, 10);
      },
      error => {
      }
    );
  }

  opentimeOutPopup() {
    this.countdownTimeSecond = 300;
    this.modalReference = this.modalService.open(this.timeOutModal, { centered: true, windowClass: 'cardEnableModel', keyboard: false, backdrop: 'static' });
    this.intervalSecond = setInterval(() => {
      if (this.commonServices && this.commonServices.userLogedIn) {
        this.countdownTimeSecond = this.countdownTimeSecond - 1;
        if (this.countdownTimeSecond == 0) {
          this.modalReference.close();
          this.commonServices.logout().subscribe(
            data => {
              this.commonServices.resetData()
              setTimeout(() => {
                // this.router.navigate(['login'])
                this.commonServices.loginRedirectionHandle()
              }, 10);
            },
            error => {
            }
          );
        }
      }
    }, 1000);
  }
  clearIntervalFunction() {
    clearInterval(this.intervalMain);
  }
  public convertHoursForTable(value) {
    if (value == 0) {
      return "00:00";
    }
    value = Number(value);
    // var h = Math.floor(value / 3600);
    var m = Math.floor(value % 3600 / 60);
    var s = Math.floor(value % 3600 % 60);
    // var hDisplay = this.setrZero(h);
    var mDisplay = this.setrZero(m);
    var sDisplay = this.setrZero(s);
    return mDisplay + ':' + sDisplay;
  }

  private setrZero(val) {
    if (val) {
      val = val.toString();
      if (val.length == 1) {
        val = '0' + val
      }
    } else {
      val = '00'
    }
    return val
  }
  restartTimeOut() {
    this.clearIntervalFunction();
    clearInterval(this.intervalSecond);
    this.intervalSecond = undefined;
    this.firstTimeout();
    this.modalReference.close();
  }

  openTncmodal() {
    this.clickTrack('openTnC_popup', 'click')
    this.tnCModalRef =  this.modalService.open(this.tnCModel, { centered: true, windowClass: 'cardEnableModel' });
  }

  openOtpPopup(type?) {
    this.clickTrack('openOTP_popup', 'auto')
    this.setUpSuccesFulChecks = type
    if (this.pinSetupRef) {
      this.pinSetupRef.close()
    }
    else {
      this.modalService.open(this.otpModal, { centered: true, windowClass: 'cardEnableModel', keyboard: false, backdrop: 'static' });
    }
  }


  openSetupSucessful(type?, status?, refrence?) {
    this.clickTrack('openSuccessful_popup', 'auto')
    if (type) {
      this.setUpSuccesFulChecks = type;
    }
    if (this.pinSetupRef) {
      this.pinSetupRef.close()
    }
    this.modalService.open(this.setupSucessful, { centered: true, windowClass: 'cardEnableModel', keyboard: false, backdrop: 'static' });
    setTimeout(() => {
      this.redirectHandle(type, status, refrence)
    }, 2000);

    // this.clickTrack('openSuccessful_popup', 'auto')
    //   if (type) {
    //     this.setUpSuccesFulChecks = type;
    //   }
    //   if (this.pinSetupRef) {
    //     this.pinSetupRef.close()
    //   }
    //   this.modalService.open(this.setupSucessful, { centered: true, windowClass: 'cardEnableModel', keyboard: false, backdrop: 'static' });
    //   setTimeout(() => {
    //     this.closeModal();
    //     if (type && type == 'pinSetup' && !this.pinSetupRef) {
    //       this.router.navigate(['/onboard'])
    //     }
    //     else {
    //       this.router.navigate(['/dashboard'])
    //     }
    //   }, 2000);
  }

  openOptOutPopup() {
    this.clickTrack('openOptOut_popup', 'click')
    this.modalService.open(this.optOutModal, { centered: true, windowClass: 'cardEnableModel', keyboard: false, backdrop: 'static' });
  }

  public otpChangeInput(otp) {
    this.otpNumber = null
    if (otp && otp.length == 6) {
      this.otpNumber = otp;
    }
  }

  submitOtp(otp) {
    this.modalService.dismissAll()
    this.openSetupSucessful()
    // this.ngxService.start()
    // this.commonServices.postOtp(otp).subscribe(
    //   res=>{
    //     this.clickTrack('otpSubmitted','submit')
    //     this.ngxService.stop()
    //     this.modalService.dismissAll()
    //     this.openSetupSucessful()
    //   },
    //   err =>{
    //     this.ngxService.stop()
    //     this.toastr.error("Something went wrong, please try again later!")
    //   }
    // )
  }

  // resendOtp(id){
  //    this.ngxService.start()
  //    this.commonServices.getResendOtp(id).subscribe(
  //     res=>{
  //       this.clickTrack('otpResend','click')
  //       this.ngxService.stop()
  //       this.toastr.success("OTP Sent Succesfuly !!")
  //     },
  //     err =>{
  //       this.ngxService.stop()
  //       if(err && err.error.cause && err.error.cause.includes('You have reached your limit for sending OTPs')){
  //         this.toastr.error("You have reached daily limit for sending OTPs")
  //       }
  //       else{
  //         this.toastr.error("Something went wrong, please try again later!")
  //       }
  //     }
  //   )
  // }



  closeModal() {
    this.modalService.dismissAll()
    clearTimeout(this.blockTimeOutVar)
  }

  clickTrack(label, action) {
    this.commonServices.trackUser(label, action, null)
  }

  changeLanguage(data) {
    this.commonServices.userSelectedLanguage.next(data);
  }

  openCreatePinPopup() {
    this.clickTrack('open_createPin_popup', 'click')
    this.global.setupPinType = 'updatePin'
    this.pinSetupRef = this.modalService.open(this.createPinModal, { centered: true, windowClass: 'cardEnableModel', keyboard: false, backdrop: 'static' });
  }

  openLanguagePopup() {
    this.clickTrack('open_openLanguage_popup', 'click')
    // const bottomSheetRef = this.bottomSheet.open(this.languageModal, { panelClass: 'languageUsModal' });

  }

  openDataNotFoundPopup() {
    this.clickTrack('open_noDataFound_popup', 'click')
    this.modalService.open(this.dataNotFoundModal, { centered: true, windowClass: 'cardEnableModel', keyboard: false, backdrop: 'static' });
  }

  openFailureModal() {
    this.clickTrack('open_failure_popup', 'click')
    this.modalService.open(this.failureModal, { centered: true, windowClass: 'cardEnableModel', keyboard: false, backdrop: 'static' });
  }

  openIncorrectModal() {
    this.clickTrack('open_incorrectOtpModal_popup', 'click')
    this.modalService.open(this.incorrectOtpModal, { centered: true, windowClass: 'cardEnableModel', keyboard: false, backdrop: 'static' });
  }

  // openCardBlockModal(){
  //   this.clickTrack('open_cardBlockModal_popup','click')
  //   this.modalService.open(this.cardBlockModal, { centered: true , windowClass:'cardEnableModel' ,keyboard: false, backdrop:'static' });
  // }

  ngOnDestroy() {
    clearTimeout(this.clearIntervalForSetupSuccess)
    this.closeModal()
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  openRatingPopup() {
    this.clickTrack('openRatingPopup', 'click')
    this.ratingValue = 0
    this.modalService.open(this.experienceRate, { centered: true, windowClass: 'cardEnableModel', keyboard: false, backdrop: 'static' });
  }

  postExperienceRating(ratingData) {
    this.ngxService.start()
    this.clickTrack('post Experience Rating', 'click')
    this.commonServices.postExperienceRatingDetail(ratingData, this.ratingValue).subscribe(
      res => {
        this.clickTrack('post Experience Rating Success', 'apiCall')
        this.ngxService.stop()
        this.clickTrack('close Experience Rating popup after succesful rating ', 'auto')
        this.modalService.dismissAll()
        this.openFeedbackSuccess()
      },
      err => {
        this.ngxService.stop()
        this.clickTrack('post Experience Rating Failure', 'apiCall')
        this.toastr.error("Something went wrong, please try again later!")
      }
    )
  }

  ratingInputCall(event, rate) {
    this.ratingValue = rate
  }

  openFeedbackSuccess() {
    this.clickTrack("open feedback success popup", "auto")
    this.modalService.open(this.feedbackSuccess, { centered: true, windowClass: 'cardEnableModel', keyboard: false, backdrop: 'static' });
    setTimeout(() => {
      this.modalService.dismissAll()
    }, 3000);
  }

  openGetAddOnCardPopup() {
    if (this.commonServices['dashboardManageData']['addOnUrl']) {
      this.showPopper = false
      this.clickTrack("open get add on card popup", "auto")
      sessionStorage.setItem("addOnPopupOpen", "addOnPopupOpen")
      this.modalService.open(this.getAddOnCard, { centered: true, windowClass: 'addOnCardModel', keyboard: false, backdrop: 'static' });
      setTimeout(() => {
        this.showPopper = true
      }, 1500);
    }
  }

  redirectHandle(type, status, refrence?) {
    this.closeModal();
    var delay = 2000
    if (status && !this.commonServices.dashboardManageData['userInfo']['corporateCard']) {
      delay = 9000
      if (type == 'dashboardSetup') {
        sessionStorage.setItem('dashboardActivation', 'dashboardActivation')
      }
      sessionStorage.setItem("onboardActivation", "onboardActivation")
      if (sessionStorage.getItem("utm_source") || (sessionStorage.getItem("uniqueId") && this.commonServices.dashboardManageData['rewardResponse']) || this.commonServices.dashboardManageData['rewardResponse']) {
        this.router.navigate(['/onboardV1'])
      }
      else {
        this.router.navigate(['/onboard'])
      }
    }
    else {
      this.router.navigate(['/dashboard'])
    }
    // if(type == 'dashboardSetup' && this.commonServices?.dashboardManageData && this.commonServices.dashboardManageData['addOnUrl'] && !refrence && !sessionStorage.getItem("addOnPopupOpen")){
    //   if(this.commonServices.dashboardManageData['rewardResponse'] && this.commonServices.dashboardManageData['rewardResponse'].toLowerCase() == this.config.rewardFeatureV2TimesPrimeKey){
    //     delay = 0
    //   }
    //   setTimeout(() => {
    //     this.openGetAddOnCardPopup()
    //   }, delay);
    // }
  }

  changesForSetupSCreen() {
    this.closeModal()
  }

  openCardUnblockedPopup() {
    clearTimeout(this.blockTimeOutVar)
    this.clickTrack('open oblock unblocked popup', 'auto')
    this.modalService.open(this.cardUnblocked, { centered: true, windowClass: 'cardEnableOblockModel', keyboard: false, backdrop: 'static' });
    this.blockTimeOutVar = setTimeout(() => {
      this.closeModal()
      this.clickTrack('close oblock unblocked popup', 'auto')
      clearTimeout(this.blockTimeOutVar)
    }, 3200);
  }

  openAttemptExhaustModal() {
     this.modalService.open(this.attemptExhaustModal, { centered: true, windowClass: 'cardEnableOblockModel', keyboard: false, backdrop: 'static' });
     this.clickTrack('open oblock attempt exhaust modal', 'auto')
  }
}
